// @ts-check

import { mapGetters } from 'vuex'

/**
 * @deprecated Use the [composable](../composables/company/useDemoMode.js) instead
 * @type {import("vue").ComponentOptionsMixin}
 */
export const demoMixin = {
  computed: {
    ...mapGetters('companyData', ['isInDemoMode'])
  },
  methods: {
    /**
     * Executes the given callback function if the user is not in demo mode.
     * @param {Function} callback
     * @param params
     */
    async skipInDemoMode(callback, ...params) {
      if (this.isInDemoMode) {
        return
      }
      await callback(...params)
    }
  }
}

export default demoMixin
